// extracted by mini-css-extract-plugin
export default {"subtitulo":"ProgramarServicio_subtitulo__jvYeZ","spinnerContainer":"ProgramarServicio_spinnerContainer__N8Ns8"};